import React, { useRef } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaperPlane,
  faDownload,
  faEnvelope,
  faLocationDot,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faGithub,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

const tech = [
  "React",
  "Next.js",
  "React Native",
  "TypeScript",
  "Firebase",
  "Cloudflare",
];

export default function Touchwithme() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    const { from_name, from_email, message } = form.current;
    if (!from_name.value.trim()) return toast.error("Enter your name");
    if (!from_email.value.trim()) return toast.error("Enter your email");
    if (!message.value.trim()) return toast.error("Enter a message");
    emailjs
      .sendForm("service_qrx1x9z", "template_pwlpl89", form.current, {
        publicKey: "b0_x_zeRXqRvwL22H",
      })
      .then(
        () => toast.success("Message sent!"),
        () => toast.error("Something went wrong"),
      );
  };

  return (
    <section className="relative overflow-hidden bg-custombg py-24 px-6">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-24 h-[450px] w-[450px] rounded-full bg-purple-500/20 blur-[120px]" />
        <div className="absolute -bottom-24 -right-24 h-[500px] w-[500px] rounded-full bg-blue-500/20 blur-[140px]" />
        <div className="absolute top-1/3 left-1/2 h-[320px] w-[320px] -translate-x-1/2 rounded-full bg-pink-500/20 blur-[120px]" />
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.04)_1px,transparent_1px)] bg-[size:40px_40px]" />
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />

      <div className="relative mx-auto max-w-7xl grid lg:grid-cols-[420px_1fr] gap-32 items-start">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-8 sticky top-24"
        >
          <div className="inline-flex items-center gap-2 rounded-full bg-green-500/15 px-4 py-2 text-green-300 text-sm">
            <FontAwesomeIcon icon={faBriefcase} /> Available for Work
          </div>

          <h2 className="mt-6 text-4xl font-bold text-white">
            Let's Build Something Amazing.
          </h2>
          <p className="mt-4 text-gray-400">
            Open to full-time opportunities, freelance projects and exciting
            product ideas.
          </p>

          <div className="mt-8 space-y-4 text-gray-300">
            <div className="flex items-center gap-3">
              <FontAwesomeIcon icon={faEnvelope} className="text-yellow-400" />
              chaubeypushkar4@gmail.com
            </div>
            <div className="flex items-center gap-3">
              <FontAwesomeIcon icon={faWhatsapp} className="text-green-400" />
              +91 7023781208
            </div>
            <div className="flex items-center gap-3">
              <FontAwesomeIcon icon={faLocationDot} className="text-red-400" />
              India
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {tech.map((t) => (
              <span
                key={t}
                className="rounded-full border border-yellow-400/20 bg-yellow-400/10 px-3 py-1 text-xs text-yellow-300"
              >
                {t}
              </span>
            ))}
          </div>

          <div className="mt-8 flex gap-3">
            <a
              href="https://drive.google.com/file/d/1chjBSr4Vamk_xEf2-K4hbxWpqMHHKcBd/view?usp=drive_link"
              target="_blank"
              rel="noreferrer"
              className="flex-1 rounded-xl bg-yellow-400 py-3 text-center font-semibold text-black"
            >
              <FontAwesomeIcon icon={faDownload} /> Download Resume
            </a>
            <a
              href="https://github.com/Pushkar155"
              target="_blank"
              rel="noreferrer"
              className="h-12 w-12 rounded-xl border border-white/10 bg-white/5 flex items-center justify-center text-white"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
            <a
              href="https://www.linkedin.com/in/pushkar-chaubey-145311202/"
              target="_blank"
              rel="noreferrer"
              className="h-12 w-12 rounded-xl border border-white/10 bg-white/5 flex items-center justify-center text-white"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </div>
        </motion.div>

        <motion.form
          ref={form}
          // error={error}
          onSubmit={sendEmail}
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-12 space-y-6 "
        >
          {/* <p className="uppercase tracking-[0.35em] text-yellow-400 font-semibold">
            Contact
          </p> */}
          <h3 className="text-5xl font-bold text-white">Send me a Message</h3>
          <p className="text-gray-400">
            Have an opportunity or project in mind? I'd love to hear from you.
          </p>

          <input
            name="from_name"
            placeholder="Your Name"
            className="w-full rounded-2xl border border-white/10 bg-black/20 p-4 text-white outline-none focus:border-yellow-400"
          />
          <input
            name="from_email"
            placeholder="Your Email"
            className="w-full rounded-2xl border border-white/10 bg-black/20 p-4 text-white outline-none focus:border-yellow-400"
          />
          <textarea
            rows="7"
            name="message"
            placeholder="Tell me about your project..."
            className="w-full rounded-2xl border border-white/10 bg-black/20 p-4 text-white outline-none resize-none focus:border-yellow-400"
          />
          <button className="flex items-center gap-2 rounded-2xl bg-yellow-400 px-8 py-4 font-semibold text-black hover:scale-105 transition">
            Send Message <FontAwesomeIcon icon={faPaperPlane} />
          </button>
        </motion.form>
      </div>
    </section>
  );
}
